<app-header [isScrolled]="true"></app-header>
<ion-content fullscreen="true">
  <div class="content" style="padding-top: 100px">
    <div class="lottie-wrapper">
  <!--    <ng-lottie [options]="options"></ng-lottie>-->
    </div>
    <h2>Thank You for Your Interest!</h2>
    <p>We appreciate you reaching out to us. Your inquiry has been received, and a member of our team will be in contact with you soon to discuss your needs and answer any questions you may have.</p>
    <p>In the meantime, please feel free to explore our website to view available properties, read our blog for helpful tips, or connect with us on social media.</p>
    <div>
    <ion-button [routerLink]="['/contact']" fill="outline">Go Back</ion-button>
    <ion-button [routerLink]="['/']">Go to Home</ion-button>
    </div>
  </div>
  <app-footer></app-footer>
</ion-content>
